import instance from './common';

const getInitialConfiguration = (http = instance) => {
  // return {
  //   "code": 0,
  //   "msg": "",
  //   "data": {
  //      "customer_enabled":true, //check if customer ready
  //      "username": "dli@conviva.com",
  //      "is_selected": true,
  //      "profile_id": 1399191,
  //      "primary": false,
  //      "tz_name": "Asia/Calcutta",
  //      "timezone": 5.5,
  //      "customer_name": "c3.AltBalaji",
  //      "customer_id": 1960185955,
  //      "role": "Admin",
  //      "hidden": true,
  //      "api_key": "667adf8e6386aec1b5f06cb8e393ac48e2354685"
  //   }
  // }
  return http.get('/v1/init');
};
export default getInitialConfiguration;
